<template>
  <div>
    <multiselect v-model="localModel" id="ajaxPartner" :custom-label="partnerLabel" @input="onChange" 
      track-by="id" :placeholder="$t('project.investment.form.history.partner')" 
      open-direction="bottom"
      :options="partners" :multiple="false" :searchable="true" :loading="isLoadingPartner" 
      :internal-search="false" :clear-on-select="true" :close-on-select="true" 
      :options-limit="300" :max-height="600" :show-no-results="true" 
      :hide-selected="true" @search-change="asyncFindPartner"
      v-bind:deselect-label="$t('multiselect.deselect-label')"
      v-bind:selectedLabel="$t('multiselect.selectedLabel')"
      v-bind:select-label="$t('multiselect.select-label')">
      <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
    </multiselect>
  </div>
</template>

<script>
  import {PartnerServiceClient, PartnerDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'EntrepreneurMultiselect',
    props: {
      model: {},
    },
    data() {
      return {
        localModel: {},
        partners: [],
        isLoadingPartner: false,
      }
    },
    watch: {
      model: {
        immediate: true,
        handler(newVal, oldVal) {
          this.localModel = newVal
        },
      },
    },
    inject: ['$validator'],
    methods: {
      onChange(value) {
        this.$emit('update', value)
      },
      partnerLabel: function(obj) {
        return obj.name
      },
      asyncFindPartner: function(query) {
        if (!this.isLoading) {
          this.isLoading = true

          let service = ServiceFactory.create(PartnerServiceClient)
          let self = this

          service.getAutoComplet(query).then(response => {
            self.partners = response
            self.isLoadingPartner = false
          })
        }
      },
    },
    components: {
      multiselect: Multiselect,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/shared/multiselect/PartnerMultiselect.vue